"use client";

import { useFormContext } from "react-hook-form";
import { LifePlanSummary } from "@/components/life-plan-summary";
import { useI18n } from "@/lib/i18n/hook";

export function StepConfirmation() {
  const { getValues } = useFormContext();
  const { t } = useI18n();
  const values = getValues();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">{t("lifePlan.confirmation.title")}</h2>
      <LifePlanSummary data={values} />
    </div>
  );
}
